import React from 'react';

import { classnames } from 'lib/classnames';
import { FieldValue } from 'lib/types/field';
import { ObjectId } from 'lib/types/models';

import { ActionType } from '../../type';
import OperateAction from '../edit/OperateAction';

import styles from './TransitionConfirm.module.less';

const cx = classnames(styles);
interface TransitionConfirmProps {
  field: ActionType;
  value: FieldValue;
  checked: boolean;
  handleCheckChange: (key: string, checked: boolean) => void;
  fieldChange: (key: string, data: FieldValue) => void;
  workspaceId: ObjectId;
}

const TransitionConfirm: React.VFC<TransitionConfirmProps> = ({
  field,
  value,
  checked,
  fieldChange,
  handleCheckChange,
  workspaceId,
}) => {
  return (
    <div className={cx('transition-field-component')}>
      <OperateAction
        workspaceId={workspaceId}
        key={field.objectId}
        checked={checked}
        field={field}
        fieldChange={data => fieldChange(field.key, data)}
        checkChange={checked => handleCheckChange(field.key, checked)}
        value={value}
      />
    </div>
  );
};

export default TransitionConfirm;
